import React from "react";

/*
    Params:
    @text: string;
    @type: fullfilled | outline;
    @onClickButton: () => void;
    @classNames: string;
    @style: React.CSSProperties;
*/
const Button = ({ text, type, onClickButton, classNames, style }) => {
  const typeStyles = {
    fullfilled: "bg-[#0ee2ff] text-black",
    outline: "bg-black text-white",
    default: "bg-[#0ee2ff] text-black",
    linear: "bg-gradient-to-t from-[#008cd5] to-[#0ee2ff]"
  };
  const borderStyle = typeStyles[type] || typeStyles.default;

  return (
    <div
      className={`px-1 md:px-5 flex font-semibold text-sm justify-center items-center w-full h-full cursor-pointer border-2 border-[#0ee2ff] ${
        type === "fullfield" && "hover:bg-[#0acde7]"
      } rounded ${borderStyle} ${
        classNames || "sm:text-xl md:text-2xl lg:text-3xl py-3 sm:py-5"
      }`}
      style={{ ...style }}
      onClick={onClickButton}
    >
      {text}
    </div>
  );
};

export default React.memo(Button);
